import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash-es';
import { DealsService } from 'src/app/services/deals.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-view-deals-payment',
  templateUrl: './view-deals-payment.component.html',
  styleUrls: ['./view-deals-payment.component.scss']
})
export class ViewDealsPaymentComponent implements OnDestroy {


  url = '';
  sanitizedUrl = '';


  dealsList: any;
  rowData: any;
  dealsId: any;
  constructor(
    private dealsService: DealsService,

    @Inject(MAT_DIALOG_DATA) data, private router: Router

  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
    this.rowData = data['finalData'];
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {


    this.dealsId = this.rowData;

    if (this.dealsId !== null) {
      this.getPayments(this.dealsId);
    }

  }
  getPayments(value) {
    this.dealsService.getDealsPaymentId(value).subscribe(
      (res) => {
        this.dealsList = res
        console.log("Payment data :", this.dealsList);


      },
      error => {

      }
    )
  }

  print() {
    window.print();
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
